/**
 * Mobile Wish Filter Bar Component
 * Dedicated filter component for wish list on mobile devices
 * Provides category, region, urgency, and search filtering
 */

import { useState } from 'react';
import styles from './MobileWishFilterBar.module.css';

interface MobileWishFilterBarProps {
  onFilterChange: (filters: {
    category?: string;
    region?: string;
    urgent?: boolean;
    search?: string;
  }) => void;
  categories: string[];
  regions: string[];
}

const MobileWishFilterBar = ({
  onFilterChange,
  categories,
  regions,
}: MobileWishFilterBarProps) => {
  const [category, setCategory] = useState<string>('');
  const [region, setRegion] = useState<string>('');
  const [urgent, setUrgent] = useState<boolean>(false);
  const [search, setSearch] = useState<string>('');

  const handleFilterSubmit = () => {
    onFilterChange({
      category: category || undefined,
      region: region || undefined,
      ...(urgent ? { urgent: true } : {}),
      search: search || undefined,
    });
  };

  const handleReset = () => {
    setCategory('');
    setRegion('');
    setUrgent(false);
    setSearch('');
    onFilterChange({});
  };

  const hasActiveFilters = category || region || urgent || search;

  return (
    <div className={styles.filterBar}>
      <div className={styles.filterBar__header}>
        <h3 className={styles.filterBar__title}>篩選條件</h3>
        {hasActiveFilters && (
          <button className={styles.resetBtn} onClick={handleReset}>
            清除
          </button>
        )}
      </div>

      <div className={styles.filterBar__filters}>
        {/* Search Input */}
        <div className={styles.filterBar__field}>
          <label className={styles.filterBar__label}>關鍵字搜尋</label>
          <input
            type="text"
            className={styles.filterBar__input}
            placeholder="搜尋許願標題或描述..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {/* Category Select */}
        <div className={styles.filterBar__field}>
          <label className={styles.filterBar__label}>服務類別</label>
          <select
            className={styles.filterBar__select}
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">所有類別</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>
        </div>

        {/* Region Select */}
        <div className={styles.filterBar__field}>
          <label className={styles.filterBar__label}>地區</label>
          <select
            className={styles.filterBar__select}
            value={region}
            onChange={(e) => setRegion(e.target.value)}
          >
            <option value="">所有地區</option>
            {regions.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </div>

        {/* Urgent Checkbox */}
        <div className={styles.filterBar__field}>
          <label className={styles.filterBar__checkboxLabel}>
            <input
              type="checkbox"
              checked={urgent}
              onChange={(e) => setUrgent(e.target.checked)}
              className={styles.filterBar__checkbox}
            />
            <span>只顯示急件</span>
          </label>
        </div>

        {/* Submit Button */}
        <button className={styles.applyBtn} onClick={handleFilterSubmit}>
          套用篩選
        </button>
      </div>
    </div>
  );
};

export default MobileWishFilterBar;
